import { render, staticRenderFns } from "./BaseSimplePhoneField.vue?vue&type=template&id=18591ada&"
import script from "./BaseSimplePhoneField.vue?vue&type=script&lang=ts&"
export * from "./BaseSimplePhoneField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports